import { InjectionToken } from '@angular/core';

export let BASE_URL = new InjectionToken<string>('BaseUrl');
